import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "detail_container"
}
const _hoisted_2 = { class: "detail_base-info card-white-6" }
const _hoisted_3 = { class: "detail_header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "账单信息", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_6 = {
  key: 0,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 2,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 3,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_16 = {
  key: 4,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode("添加关联")
const _hoisted_18 = { class: "hw_detail_table_container card-white-6" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { style: {"margin-right":"8px"} }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_WeEditableWarp = _resolveComponent("WeEditableWarp")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_email_cards = _resolveComponent("email-cards")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_table_action = _resolveComponent("table-action")!
  const _component_billing = _resolveComponent("billing")!
  const _component_FlowTimeLine = _resolveComponent("FlowTimeLine")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_edit_email = _resolveComponent("edit-email")!
  const _component_GenerateBillPdf = _resolveComponent("GenerateBillPdf")!
  const _component_page_detail_wrapper = _resolveComponent("page-detail-wrapper")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_page_detail_wrapper, _mergeProps(_ctx.$attrs, {
    title: (_ctx.bill.name || '') + (_ctx.bill.is_deleted ? ' [DELETED]' : ''),
    drop_down_menus: _ctx.get_drop_down_menus,
    collapsed: true
  }), {
    default: _withCtx(() => [
      (!_ctx.isEmptyData(_ctx.bill))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                (
              (_ctx.isAdmin || _ctx.isFinance) &&
              !_ctx.bill.is_parent_bill &&
              _ctx.bill.billing_type === _ctx.model.Bill.BILLING_TYPE.NORMAL &&
              !_ctx.isAutoBilling
            )
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      class: "mglf-16",
                      type: "primary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editBill(this, _ctx.bill)))
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_svg_icon, { "icon-name": "EditOutlined" })
                      ]),
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_a_form, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, {
                    gutter: 20,
                    type: "flex",
                    style: {"flex-wrap":"wrap"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "客户主体",
                            name: "rd_company_name"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.bill.rd_company_name
                              }, {
                                text: _withCtx(() => [
                                  _createElementVNode("span", null, [
                                    _createVNode(_component_a_button, {
                                      type: "link",
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.jumpToCompany(_ctx.bill.company_id))),
                                      style: {"white-space":"pre-wrap"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.bill.rd_company_name), 1)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "合同",
                            name: "name"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.contract.name
                              }, {
                                text: _withCtx(() => [
                                  _createElementVNode("span", null, [
                                    _createVNode(_component_a_button, {
                                      type: "link",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.jumpToContract(_ctx.contract))),
                                      style: {"white-space":"pre-wrap"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.contract.name), 1)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "合同归属" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.contract.rd_owner_name + ' (' + _ctx.contract.rd_team_name + ')'
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "账单归属",
                            name: "rd_owner_name"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: 
                    _ctx.bill.rd_owner_name +
                    ' (' +
                    _ctx.bill.rd_team_name +
                    ')' +
                    (_ctx.bill.rd_tracker_name ? ' / ' + _ctx.bill.rd_tracker_name : '')
                  
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "账单属性",
                            name: "rd_property"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.bill.rd_property + (_ctx.bill.is_force_manual_mode ? ' [Manual]' : '')
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "业务标签",
                            name: "rd_logic_detail"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.contract.rd_logic_detail
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "业务空间",
                            name: "rd_logic_type"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.bill.rd_logic_type
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_divider, { style: {"margin":"5px 0"} }),
                  _createVNode(_component_a_row, {
                    gutter: 20,
                    type: "flex",
                    style: {"flex-wrap":"wrap"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "暂估金额",
                            name: "finance_estimate_money"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.formatNumberByNumeral(_ctx.bill.finance_estimate_money, '0,0.00')
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "发票金额",
                            name: "finance_invoice_money"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.formatNumberByNumeral(_ctx.bill.finance_invoice_money, '0,0.00')
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "差值",
                            name: "finance_cut_money"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.formatNumberByNumeral(_ctx.bill.finance_cut_money, '0,0.00')
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.bill.time_span_id)
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 0,
                            span: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "业务区间",
                                name: "rd_time_span_name"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.bill.rd_time_span_name,
                                    edit: false
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.bill.finance_anti_invoice_money)
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 1,
                            span: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "返点金额",
                                name: "rd_time_span_name"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.bill.finance_anti_invoice_money,
                                    edit: false
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, {
                    gutter: 20,
                    type: "flex",
                    style: {"flex-wrap":"wrap"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "税率",
                            name: "tax"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.formatNumberByNumeral(_ctx.bill.tax_rate, '0.00%')
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "税额",
                            name: "tax_money"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.formatNumberByNumeral(_ctx.bill.tax_money, '0,0.00')
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "币种",
                            name: "rd_currency_name"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.bill.rd_currency_name
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, {
                    gutter: 20,
                    type: "flex",
                    style: {"flex-wrap":"wrap"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "对账截止时间",
                            name: "check_bill_deadline"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.bill.check_bill_deadline
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "对账完成时间",
                            name: "check_bill_finish_time"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.bill.check_bill_finish_time
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "对账进度",
                            name: "rd_bill_time_status"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.bill.rd_bill_time_status
                              }, {
                                text: _withCtx(() => [
                                  _createElementVNode("span", {
                                    style: _normalizeStyle({ color: _ctx.bill.rd_bill_time_status_color })
                                  }, _toDisplayString(_ctx.bill.rd_bill_time_status), 5)
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (!_ctx.bill.is_sub_bill)
                    ? (_openBlock(), _createBlock(_component_a_row, {
                        key: 0,
                        gutter: 20,
                        type: "flex",
                        style: {"flex-wrap":"wrap"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_divider, { style: {"margin":"5px 0"} }),
                          (_ctx.bill.is_demand)
                            ? (_openBlock(), _createBlock(_component_a_col, {
                                key: 0,
                                span: 24
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_row, {
                                    "a-row": "",
                                    gutter: 20,
                                    type: "flex",
                                    style: {"flex-wrap":"wrap"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_col, { span: 6 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, {
                                            label: "已收金额",
                                            name: "finance_linked_money_paid"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_WeEditableWarp, {
                                                value: _ctx.bill.finance_linked_money_paid
                                              }, {
                                                text: _withCtx(() => [
                                                  _createElementVNode("span", null, [
                                                    _createVNode(_component_a_tooltip, {
                                                      title: _ctx.$tipConfig['AMOUNT_GOT'].content,
                                                      placement: _ctx.$tipConfig['AMOUNT_GOT'].position
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_svg_icon, { "icon-name": "QuestionCircleOutlined" })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["title", "placement"]),
                                                    _createTextVNode(" " + _toDisplayString(_ctx.formatNumberByNumeral(_ctx.bill.finance_linked_money_paid, '0,0.00')), 1)
                                                  ])
                                                ]),
                                                _: 1
                                              }, 8, ["value"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_col, { span: 6 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, {
                                            label: "收款中金额",
                                            name: "finance_linked_money_paying"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_WeEditableWarp, {
                                                value: _ctx.bill.finance_linked_money_paying
                                              }, {
                                                text: _withCtx(() => [
                                                  _createElementVNode("span", null, [
                                                    _createVNode(_component_a_tooltip, {
                                                      title: _ctx.$tipConfig['AMOUNT_GETTING'].content,
                                                      placement: _ctx.$tipConfig['AMOUNT_GETTING'].position
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_svg_icon, { "icon-name": "QuestionCircleOutlined" })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["title", "placement"]),
                                                    _createTextVNode(" " + _toDisplayString(_ctx.formatNumberByNumeral(_ctx.bill.finance_linked_money_paying, '0,0.00')), 1)
                                                  ])
                                                ]),
                                                _: 1
                                              }, 8, ["value"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_col, { span: 6 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, {
                                            label: "需收款",
                                            name: "finance_to_pay_money"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_WeEditableWarp, {
                                                value: _ctx.bill.finance_to_pay_money
                                              }, {
                                                text: _withCtx(() => [
                                                  _createElementVNode("span", null, [
                                                    _createVNode(_component_a_tooltip, {
                                                      title: _ctx.$tipConfig['TO_GET'].content,
                                                      placement: _ctx.$tipConfig['TO_GET'].position
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_svg_icon, { "icon-name": "QuestionCircleOutlined" })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["title", "placement"]),
                                                    _createTextVNode(" " + _toDisplayString(_ctx.formatNumberByNumeral(_ctx.bill.finance_to_pay_money, '0,0.00')), 1)
                                                  ])
                                                ]),
                                                _: 1
                                              }, 8, ["value"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_a_col, {
                                key: 1,
                                span: 24
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_row, {
                                    "a-row": "",
                                    gutter: 20,
                                    type: "flex",
                                    style: {"flex-wrap":"wrap"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_col, { span: 6 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, {
                                            label: "已付金额",
                                            name: "finance_linked_money_paid"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_WeEditableWarp, {
                                                value: _ctx.bill.finance_linked_money_paid
                                              }, {
                                                text: _withCtx(() => [
                                                  _createElementVNode("span", null, [
                                                    _createVNode(_component_a_tooltip, {
                                                      title: _ctx.$tipConfig['AMOUNT_PAID'].content,
                                                      placement: _ctx.$tipConfig['AMOUNT_PAID'].position
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_svg_icon, { "icon-name": "QuestionCircleOutlined" })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["title", "placement"]),
                                                    _createTextVNode(" " + _toDisplayString(_ctx.formatNumberByNumeral(_ctx.bill.finance_linked_money_paid, '0,0.00')), 1)
                                                  ])
                                                ]),
                                                _: 1
                                              }, 8, ["value"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_col, { span: 6 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, {
                                            label: "支付中金额",
                                            name: "finance_linked_money_paying"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_WeEditableWarp, {
                                                value: _ctx.bill.finance_linked_money_paying
                                              }, {
                                                text: _withCtx(() => [
                                                  _createElementVNode("span", null, [
                                                    _createVNode(_component_a_tooltip, {
                                                      title: _ctx.$tipConfig['AMOUNT_PAYING'].content,
                                                      placement: _ctx.$tipConfig['AMOUNT_PAYING'].position
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_svg_icon, { "icon-name": "QuestionCircleOutlined" })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["title", "placement"]),
                                                    _createTextVNode(" " + _toDisplayString(_ctx.formatNumberByNumeral(_ctx.bill.finance_linked_money_paying, '0,0.00')), 1)
                                                  ])
                                                ]),
                                                _: 1
                                              }, 8, ["value"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_col, { span: 6 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, {
                                            label: "需支付",
                                            name: "finance_to_pay_money"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_WeEditableWarp, {
                                                value: _ctx.bill.finance_to_pay_money
                                              }, {
                                                text: _withCtx(() => [
                                                  _createElementVNode("span", null, [
                                                    _createVNode(_component_a_tooltip, {
                                                      title: _ctx.$tipConfig['TO_PAY'].content,
                                                      placement: _ctx.$tipConfig['TO_PAY'].position
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_svg_icon, { "icon-name": "QuestionCircleOutlined" })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["title", "placement"]),
                                                    _createTextVNode(" " + _toDisplayString(_ctx.formatNumberByNumeral(_ctx.bill.finance_to_pay_money, '0,0.00')), 1)
                                                  ])
                                                ]),
                                                _: 1
                                              }, 8, ["value"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })),
                          (_ctx.bill.is_demand)
                            ? (_openBlock(), _createBlock(_component_a_col, {
                                key: 2,
                                span: 24
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_row, {
                                    "a-row": "",
                                    gutter: 20,
                                    type: "flex",
                                    style: {"flex-wrap":"wrap"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_col, { span: 6 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, {
                                            label: "收款截止日期",
                                            name: "pay_money_deadline"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_WeEditableWarp, {
                                                value: _ctx.bill.pay_money_deadline
                                              }, null, 8, ["value"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_col, { span: 6 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, {
                                            label: "计划收款日期",
                                            name: "pay_money_plan_time_str"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_WeEditableWarp, {
                                                value: _ctx.bill.pay_money_plan_time_str
                                              }, null, 8, ["value"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_col, { span: 6 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, {
                                            label: "实际收款日期",
                                            name: "pay_money_finish_time"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_WeEditableWarp, {
                                                value: _ctx.bill.pay_money_finish_time
                                              }, null, 8, ["value"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_col, { span: 6 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, {
                                            label: "收款进度",
                                            name: "rd_pay_time_status"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_WeEditableWarp, {
                                                value: _ctx.bill.rd_pay_time_status
                                              }, {
                                                text: _withCtx(() => [
                                                  _createElementVNode("span", {
                                                    style: _normalizeStyle({ color: _ctx.bill.rd_pay_time_status_color })
                                                  }, _toDisplayString(_ctx.bill.rd_pay_time_status), 5)
                                                ]),
                                                _: 1
                                              }, 8, ["value"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      (_ctx.showInvoice)
                                        ? (_openBlock(), _createBlock(_component_a_col, {
                                            key: 0,
                                            span: 6
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_form_item, { label: "开票方式" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_WeEditableWarp, {
                                                    value: _ctx.bill.is_manual_invoice ? '人工开票' : '自动开票'
                                                  }, null, 8, ["value"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (_ctx.showInvoice)
                                        ? (_openBlock(), _createBlock(_component_a_col, {
                                            key: 1,
                                            span: 6
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_form_item, { label: "是否显示业务线" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_WeEditableWarp, {
                                                    value: _ctx.bill.show_buline ? '是' : '否'
                                                  }, null, 8, ["value"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_a_col, {
                                key: 3,
                                span: 24
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_row, {
                                    "a-row": "",
                                    gutter: 20,
                                    type: "flex",
                                    style: {"flex-wrap":"wrap"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_col, { span: 6 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, {
                                            label: "付款截止日期",
                                            name: "pay_money_deadline"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_WeEditableWarp, {
                                                value: _ctx.bill.pay_money_deadline
                                              }, null, 8, ["value"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_col, { span: 6 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, {
                                            label: "计划付款日期",
                                            name: "pay_money_plan_time_str"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_WeEditableWarp, {
                                                value: _ctx.bill.pay_money_plan_time_str
                                              }, null, 8, ["value"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_col, { span: 6 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, {
                                            label: "实际付款日期",
                                            name: "pay_money_finish_time"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_WeEditableWarp, {
                                                value: _ctx.bill.pay_money_finish_time
                                              }, null, 8, ["value"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_col, { span: 6 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, {
                                            label: "付款进度",
                                            name: "rd_pay_time_status"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_WeEditableWarp, {
                                                value: _ctx.bill.rd_pay_time_status
                                              }, {
                                                text: _withCtx(() => [
                                                  _createElementVNode("span", {
                                                    style: _normalizeStyle({ color: _ctx.bill.rd_pay_time_status_color })
                                                  }, _toDisplayString(_ctx.bill.rd_pay_time_status), 5)
                                                ]),
                                                _: 1
                                              }, 8, ["value"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "发票关联金额",
                                name: "invoice_linked_amount"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.formatNumberByNumeral(_ctx.bill.invoice_linked_amount, '0,0.00')
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "未关联金额",
                                name: "finance_invoice_money"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: 
                    _ctx.eq(_ctx.bill.finance_invoice_money, _ctx.bill.invoice_linked_amount)
                      ? 0
                      : _ctx.formatNumberByNumeral(_ctx.bill.finance_invoice_money - _ctx.bill.invoice_linked_amount, '0,0.00')
                  
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "发票号码",
                                name: "invoice_number"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.bill.invoice_number.replace('\t', ',')
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_ctx.canEmail)
                            ? (_openBlock(), _createBlock(_component_a_col, {
                                key: 4,
                                span: 24
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_divider, { style: {"margin":"5px 0"} }),
                                  _createVNode(_component_email_cards, {
                                    contract: _ctx.bill.contract,
                                    onOnUpdate: _ctx.afterEditBill
                                  }, null, 8, ["contract", "onOnUpdate"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.bill.related_bill_id)
                            ? (_openBlock(), _createBlock(_component_a_col, {
                                key: 5,
                                span: 24
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_divider, { style: {"margin":"5px 0"} }),
                                  _createVNode(_component_a_form_item, { label: "内部关联账单" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: _ctx.bill.rd_related_bill_name,
                                        edit: false
                                      }, {
                                        text: _withCtx(() => [
                                          _createElementVNode("span", null, [
                                            _createVNode(_component_a_button, {
                                              type: "link",
                                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.jumpToBill({ id: _ctx.bill.related_bill_id })))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.bill.rd_related_bill_name), 1)
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_a_divider, { style: {"margin":"5px 0"} }),
                        _createVNode(_component_a_row, {
                          gutter: 20,
                          type: "flex",
                          style: {"flex-wrap":"wrap"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, { label: "主账单" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.bill.parent_bill.name
                                    }, {
                                      text: _withCtx(() => [
                                        _createVNode(_component_a_button, {
                                          type: "link",
                                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.jumpToBill(_ctx.bill.parent_bill)))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.bill.parent_bill.name), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, { label: "主账单归属" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.bill.parent_bill.rd_owner_name + ' (' + _ctx.bill.parent_bill.rd_team_name + ')'
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ], 64))
                ]),
                _: 1
              })
            ]),
            (_ctx.bill.hedge_source_bill_id || _ctx.bill.hedged_bill_id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_ctx.hedgeBillList.length > 0)
                    ? (_openBlock(), _createBlock(_component_we_table, _mergeProps({ key: 0 }, _ctx.hedgeBillListConfig, { dataSource: _ctx.hedgeBillList }), {
                        type: _withCtx(({ record }) => [
                          (record.hedged_bill_id)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "红字账单"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_8, "蓝字账单"))
                        ]),
                        name: _withCtx(({ text, record }) => [
                          (record.id === _ctx.bill.id)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(text), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                onClick: ($event: any) => (_ctx.jumpToBill(record))
                              }, _toDisplayString(text), 9, _hoisted_10))
                        ]),
                        rd_state_name: _withCtx(({ text, record }) => [
                          _createElementVNode("span", {
                            style: _normalizeStyle({ color: record.rd_state_color })
                          }, _toDisplayString(text), 5)
                        ]),
                        _: 1
                      }, 16, ["dataSource"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.bill.is_parent_bill)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_ctx.subBillList)
                    ? (_openBlock(), _createBlock(_component_we_table, _mergeProps({ key: 0 }, _ctx.subBillListConfig, { dataSource: _ctx.subBillList }), {
                        action: _withCtx(({ record, column }) => [
                          _createVNode(_component_table_action, {
                            actions: _ctx.handleSubBillsActions(record, column)
                          }, null, 8, ["actions"])
                        ]),
                        name: _withCtx(({ text, record }) => [
                          _createVNode(_component_a_button, {
                            type: "link",
                            onClick: ($event: any) => (_ctx.jumpToBill(record))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(text), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        rd_owner_name: _withCtx(({ text, record }) => [
                          (record.billing_type === _ctx.model.Bill.BILLING_TYPE.NORMAL && _ctx.canAssign)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "link",
                                onClick: ($event: any) => (_ctx.assignBill(record))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(text), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(text), 1))
                        ]),
                        rd_state_name: _withCtx(({ text, record }) => [
                          _createElementVNode("span", {
                            style: _normalizeStyle({ color: record.rd_state_color })
                          }, _toDisplayString(text), 5)
                        ]),
                        _: 1
                      }, 16, ["dataSource"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            ((_ctx.isFinance || _ctx.isAdmin) && (_ctx.bill.is_normal_bill || _ctx.bill.is_parent_bill) && !_ctx.isEmptyData(_ctx.linkPayList))
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_ctx.linkPayList)
                    ? (_openBlock(), _createBlock(_component_we_table, _mergeProps({ key: 0 }, _ctx.linkPayListConfig, { dataSource: _ctx.linkPayList }), {
                        name: _withCtx(({ text, record }) => [
                          _createVNode(_component_a_button, {
                            type: "link",
                            onClick: ($event: any) => (_ctx.jumpToPay(record))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(text), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        rd_state_name: _withCtx(({ text, record }) => [
                          _createElementVNode("span", {
                            style: _normalizeStyle({ color: record.rd_state_color })
                          }, _toDisplayString(text), 5)
                        ]),
                        _: 1
                      }, 16, ["dataSource"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, "无"))
                ]))
              : _createCommentVNode("", true),
            ((_ctx.isFinance || _ctx.isAdmin) && !_ctx.isEmptyData(_ctx.bill.invoice_linked_list))
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_we_table, _mergeProps(_ctx.linkInvoiceListConfig, {
                    dataSource: _ctx.bill.invoice_linked_list
                  }), {
                    name: _withCtx(({ text, record }) => [
                      _createVNode(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (_ctx.jumpToInvoice(record.id))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(text), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    rd_state_name: _withCtx(({ text, record }) => [
                      _createElementVNode("span", {
                        style: _normalizeStyle({ color: record.color })
                      }, _toDisplayString(text), 5)
                    ]),
                    _: 1
                  }, 16, ["dataSource"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_billing, {
              ref: "billing",
              bill: _ctx.bill,
              contract: _ctx.contract,
              billing: _ctx.bill.billing,
              onChange: _ctx.afterEditBill
            }, null, 8, ["bill", "contract", "billing", "onChange"]),
            (_ctx.bill.parent_id === 0 && _ctx.bill.is_rebate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_we_table, _mergeProps(_ctx.rebateBillListConfig, { dataSource: _ctx.rebateBillList }), {
                    headerButton: _withCtx(() => [
                      (_ctx.canLinkRebate)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            type: "primary",
                            onClick: _ctx.openLinkRebateBillDialog
                          }, {
                            default: _withCtx(() => [
                              _hoisted_17
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    bill_name: _withCtx(({ text, record }) => [
                      _createVNode(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (_ctx.jumpToBill({ id: record.bill_id }))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(text), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    bill_rd_state_name: _withCtx(({ text, record }) => [
                      _createElementVNode("span", {
                        style: _normalizeStyle({ color: record.rd_state_color })
                      }, _toDisplayString(text), 5)
                    ]),
                    _: 1
                  }, 16, ["dataSource"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              (!_ctx.isEmptyData(_ctx.bill.flow))
                ? (_openBlock(), _createBlock(_component_FlowTimeLine, {
                    key: 0,
                    flow: _ctx.bill.flow,
                    onOnCatchFlag: _ctx.catchFlowFlag,
                    onOnUpdate: _ctx.afterEditBill
                  }, null, 8, ["flow", "onOnCatchFlag", "onOnUpdate"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.linkRebateBillDialog)
        ? (_openBlock(), _createBlock(_component_a_modal, {
            key: 1,
            visible: _ctx.linkRebateBillDialog,
            "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.linkRebateBillDialog) = $event)),
            width: "1000px",
            centered: "",
            title: "关联返点账单"
          }, {
            footer: _withCtx(() => [
              _createElementVNode("span", _hoisted_20, "未关联金额: " + _toDisplayString(_ctx.formatMoneyByRound(_ctx.linkRebateBillUnlinked)), 1),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.linkRebateBillDialog = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.linkRebateBill
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            default: _withCtx(() => [
              (!_ctx.isEmptyData(_ctx.linkRebateBillList))
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_a_form, { ref: "linkForm" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_table, {
                          dataSource: _ctx.linkRebateBillList,
                          columns: _ctx.linkRebateBillListColumns,
                          pagination: false,
                          rowKey: 
              (_record, index) => {
                return index;
              }
            ,
                          "row-selection": {
              selectedRowKeys: _ctx.BillSelectedRowKeys,
              onChange: _ctx.linkBillCheckAllChange,
              onSelect: _ctx.linkBillChange,
            }
                        }, {
                          link_money: _withCtx(({ record, index }) => [
                            _createVNode(_component_a_input_number, {
                              disabled: !record.is_checked,
                              value: _ctx.linkRebateBillList[index].link_money,
                              "onUpdate:value": ($event: any) => ((_ctx.linkRebateBillList[index].link_money) = $event),
                              onChange: ($event: any) => (_ctx.linkMoneyChanged(record))
                            }, null, 8, ["disabled", "value", "onUpdate:value", "onChange"])
                          ]),
                          _: 1
                        }, 8, ["dataSource", "columns", "rowKey", "row-selection"])
                      ]),
                      _: 1
                    }, 512)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["visible"]))
        : _createCommentVNode("", true),
      (!_ctx.isEmptyData(_ctx.editEmailValue))
        ? (_openBlock(), _createBlock(_component_edit_email, {
            key: 2,
            value: _ctx.editEmailValue,
            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editEmailValue) = $event)),
            entity: _ctx.bill,
            entityType: "bill",
            onSent: _ctx.afterEditBill
          }, null, 8, ["value", "entity", "onSent"]))
        : _createCommentVNode("", true),
      _createVNode(_component_GenerateBillPdf, {
        bill: _ctx.bill,
        ref: "GenerateBillPdfRef",
        onGenerate_done: _ctx.initData,
        onGenerate_done_send: _cache[8] || (_cache[8] = ($event: any) => {
        _ctx.initData();
        _ctx.openEmailDialog();
      })
      }, null, 8, ["bill", "onGenerate_done"])
    ]),
    _: 1
  }, 16, ["title", "drop_down_menus"])), [
    [_directive_loading, _ctx.billDetailLoading]
  ])
}